module.exports = __webpack_public_path__ + "img/banner3.2eb58150.jpg";